import React from 'react';
import {UserProfileScreen} from './UserProfile';
import { HospitalProfile } from './HospitalProfile';
import {useRole} from '@/hooks';

export const ProfileScreen: React.FC = () => {
  const {isPatient, isSpecialist, isHospitalPoc} = useRole();
  if (isPatient || isSpecialist) {
    return <UserProfileScreen />;
  }
  if (isHospitalPoc) {
    return <HospitalProfile />;
  }
  return 'No Profile';
};
